import { Injectable } from '@angular/core';
import { CookieService, CookieOptions } from 'ngx-cookie';

@Injectable()
export class CookieClientService {

  cookieOpts: CookieOptions = {};
  constructor(private _cookie : CookieService) {
    //this.cookieOpts.secure = true;
  }

  getValue(key:string){
    return this._cookie.get(key);
  }

  getObject(key:string){
    return this._cookie.getObject(key);
  }

  setValue(key: string, value: string, expired : Date){
    this.cookieOpts.expires = expired;
    this._cookie.put(key, value, this.cookieOpts);
  }

  setObject(key: string, value: Object, expired : Date){
    this.cookieOpts.expires = expired;
    this._cookie.putObject(key, value, this.cookieOpts);
  }

  remove(key: string, options?: CookieOptions){
    this._cookie.remove(key, this.cookieOpts);
  }

}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/utils/cookieClient.ts